import React from 'react'
import { NavLink } from 'react-router-dom'
import youth from '../image/youth.jpg'

const Varietydetails11 = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
        <div>
        <NavLink to="https://www.youtube.com/watch?v=hWgvvTb8iAc"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=hWgvvTb8iAc">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={youth} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            K-drama
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Youth
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>K-drama
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  November 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episodes: </span>TBA
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
        <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On May 14, 2023, Korean drama and animation production company known as Chorokbaem Media unveiled the first teaser video for the upcoming K-drama series titled 'Youth,' at the 2023 Korea Expo in Paris. The series in based on the BTS Universe (BU) storyline, a fictional narrative created by BTS at which tells the story of 7 young men navigating the transition to adulthood. It has been in work since its announcement in 2019 by HYBE.</p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>The BU storyline was presented through BTS content such as music videos, short films, and album notes. This included visuals such as their webtoon 'Save Me', the book 'The Notes 1,' 'The Notes 2,' and the 'BTS Universe Story' mobile game. </p>
  </div>
</div>
        </div>      
    </div>
  )
}

export default Varietydetails11
